import { useState } from "react"
import { fetchSalesGraph } from "../../Common/API";
import { useEffect } from "react";
import { createContext } from "react";
import moment from "moment";

const initialState = {
    dashboardData: { isLoad: false, dashboardList: [] }
}

const reportInitialState = {
    dashboardData: { isLoad: false, reportData: [] }
}

export const SalesReportsContext = createContext(initialState);

export const SalesReportProvider = ({ children }) => {
    const To = new Date();
    const From = new Date(To.getFullYear() - 1, To.getMonth(), To.getDate());
    const payload = {
        "fromDate": moment(From).format('yyyy-MM-DD'),
        "toDate": moment(To).format('yyyy-MM-DD'),
        "uid": localStorage.getItem('userId'),
    }
    const [allReportResponse, setAllReportResponse] = useState(reportInitialState);

    const getDashboardData = async (reqObj) => {
        const fetchReport = await fetchSalesGraph(reqObj);
        setAllReportResponse({ ...allReportResponse, dashboardData: { isLoad: true, reportData: fetchReport } })
    }

    useEffect(() => {
        getDashboardData(payload);
    }, []);

    const contextValues = {
        ...allReportResponse,
        getDashboardData
    }

    return (<SalesReportsContext.Provider value={contextValues}>
        {children}
    </SalesReportsContext.Provider>)
}